import { useDispatch } from 'react-redux';

import { resetSites } from 'services/filters/sites/sitesFilterSlice';
import { resetGroup } from 'services/filters/groups/groupsFilterSlice';
import { resetCamera } from 'services/filters/cameras/camerasFilterSlice';

const useResetSelectedFilterIds = () => {
  const dispatch = useDispatch();

  const resetSelectedFilterIds = () => {
    dispatch(resetSites());
    dispatch(resetGroup());
    dispatch(resetCamera());
  };

  return resetSelectedFilterIds;
};

export default useResetSelectedFilterIds;
